export const SET_INFO_CORPORATE = 'SET_INFO_CORPORATE'
export const SET_APPS = 'SET_APPS'
